import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/dizzy': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM214.2 238.1C222 230.3 222 217.6 214.2 209.8L196.3 192 214.2 174.1C222 166.3 222 153.6 214.2 145.8 206.4 138 193.7 138 185.9 145.8L168 163.7 150.2 145.9C142.4 138.1 129.7 138.1 121.9 145.9 114.1 153.7 114.1 166.4 121.9 174.2L139.8 192.1 121.9 210C114.1 217.8 114.1 230.5 121.9 238.3 129.7 246.1 142.4 246.1 150.2 238.3L168 220.5 185.8 238.3C193.7 246 206.3 246 214.2 238.1zM374.2 145.9C366.4 138.1 353.7 138.1 345.9 145.9L328 163.7 310.2 145.9C302.4 138.1 289.7 138.1 281.9 145.9 274.1 153.7 274.1 166.4 281.9 174.2L299.8 192.1 281.9 210C274.1 217.8 274.1 230.5 281.9 238.3 289.7 246.1 302.4 246.1 310.2 238.3L328 220.5 345.8 238.3C353.6 246.1 366.3 246.1 374.1 238.3 381.9 230.5 381.9 217.8 374.1 210L356.3 192 374.2 174.1C381.9 166.3 381.9 153.7 374.2 145.9zM248 272C212.7 272 184 300.7 184 336S212.7 400 248 400 312 371.3 312 336 283.3 272 248 272z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/dizzy.js
// module id = Z7z/
// module chunks = 144